/** Emulates Ruby TZInfo#friendly_identifier */
export function friendlyTimezone(timezone: string): string {
  return timezone.replace("_", " ").replace("/", " / ")
}
